import { inlinedQrl, useLexicalScope } from "@builder.io/qwik";
import { createFocusTrap } from "focus-trap";
import { enableBodyScroll, disableBodyScroll } from "body-scroll-lock-upgrade";
function useModal() {
  const supportClosingAnimation = /* @__PURE__ */ inlinedQrl((modal) => {
    modal.dataset.closing = "";
    modal.classList.add("modal-closing");
    const { animationDuration, transitionDuration } = getComputedStyle(modal);
    if (animationDuration !== "0s")
      modal.addEventListener("animationend", (e) => {
        if (e.target === modal) {
          delete modal.dataset.closing;
          modal.classList.remove("modal-closing");
          enableBodyScroll(modal);
          modal.close();
        }
      }, {
        once: true
      });
    else if (transitionDuration !== "0s")
      modal.addEventListener("transitionend", (e) => {
        if (e.target === modal) {
          delete modal.dataset.closing;
          modal.classList.remove("modal-closing");
          enableBodyScroll(modal);
          modal.close();
        }
      }, {
        once: true
      });
    else if (animationDuration === "0s" && transitionDuration === "0s") {
      delete modal.dataset.closing;
      modal.classList.remove("modal-closing");
      enableBodyScroll(modal);
      modal.close();
    }
  }, "useModal_supportClosingAnimation_5nm8t00SlvQ");
  const trapFocus = /* @__PURE__ */ inlinedQrl((modal) => {
    return createFocusTrap(modal, {
      escapeDeactivates: false
    });
  }, "useModal_trapFocus_LpIaeWijPdE");
  const activateFocusTrap = /* @__PURE__ */ inlinedQrl((focusTrap) => {
    try {
      focusTrap?.activate();
    } catch {
    }
  }, "useModal_activateFocusTrap_q0s6Q7dk66A");
  const deactivateFocusTrap = /* @__PURE__ */ inlinedQrl((focusTrap) => {
    focusTrap?.deactivate();
    focusTrap = null;
  }, "useModal_deactivateFocusTrap_BJ0kPOksNbA");
  const showModal = /* @__PURE__ */ inlinedQrl(async (modal) => {
    disableBodyScroll(modal, {
      reserveScrollBarGap: true
    });
    modal.showModal();
  }, "useModal_showModal_YgROFWWoxVs");
  const closeModal = /* @__PURE__ */ inlinedQrl(async (modal) => {
    const [supportClosingAnimation2] = useLexicalScope();
    await supportClosingAnimation2(modal);
  }, "useModal_closeModal_Aw9R9GEZEU4", [
    supportClosingAnimation
  ]);
  const wasModalBackdropClicked = /* @__PURE__ */ inlinedQrl((modal, clickEvent) => {
    if (!modal)
      return false;
    const rect = modal.getBoundingClientRect();
    const wasBackdropClicked = rect.left > clickEvent.clientX || rect.right < clickEvent.clientX || rect.top > clickEvent.clientY || rect.bottom < clickEvent.clientY;
    return clickEvent.pointerId === -1 ? false : wasBackdropClicked;
  }, "useModal_wasModalBackdropClicked_66TWqTR2fAM");
  return {
    trapFocus,
    activateFocusTrap,
    deactivateFocusTrap,
    showModal,
    closeModal,
    wasModalBackdropClicked,
    supportClosingAnimation
  };
}
export {
  useModal
};
